<template>
  <div class="sub-select-group">
    <p class="group-title" data-toggle="sub-group-bike" >
      <select class="group-title" ref="category_select" v-model="category">
        <option value="0">- 選択 -</option>
        <option v-for="category in categories" :key="category.id" :value="category.id">{{category.title}}</option>
      </select>
    </p>
    <div v-if="category !== 0">
      <div v-if="isExistSubCategory()">
        <select_categories :parentCategory="selectedCategory()"
                           :searchCategories="searchCategories"
                           :categories="subCategories()" v-on:selectCategory="selectCategory"></select_categories>
      </div>
      <!--
      <div v-else>
        <option_categories :parentCategory="selectedCategory()" :categories="subCategories()"  ></option_categories>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import option_categories from "components/OptionCategories";
export default {
  props: ['parentCategory', 'categories', 'searchCategories'],
  name: "select_categories",
  components: {option_categories},
  data() {
    return {
      category: 0
    }
  },
  computed: {

  },
  mounted() {
    this.setCategories()
  },
  methods: {
    setCategories() {
      for(let sc of this.searchCategories) {
        for(let category of this.categories) {
          if(sc === category.id) {
            this.category = sc
            break
          }
        }
      }
    },
    selectedCategory() {
      const index = this.$refs.category_select.selectedIndex
      if(index > 0) {
        return this.categories[index - 1].title
      }
      else {
        return ''
      }
    },
    isExistSubCategory() {
      return parseInt(this.category) > 0  && this.subCategories().length > 0
    },
    subCategories() {
      let index = 0
      for(let i = 0 ; i < this.categories.length; i ++) {
        if(this.categories[i].id === this.category) {
          index = i
          break
        }
      }
      if(index >= 0) {
        return this.categories[index].children || []
      }
      else {
        return []
      }
    },
    selectCategory(categoryId) {
      this.$emit("selectCategory", categoryId);
    }
  },
  watch: {
    parentCategory() {
      this.category = 0
    },
    category() {
      if(parseInt(this.category) !== 0) {
       this.$emit("selectCategory", this.category);
      }
    }
  }
}
</script>

<style scoped>

</style>
